// src/features/release-notes/utils.ts

/** «dd/MM/yyyy» of a `yyyy-MM-dd` date, without a time-zone shift. */
export const formatNoteDate = (value: string): string => {
  const [year, month, day] = value.split('-');
  return year && month && day ? `${day}/${month}/${year}` : value;
};
